// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"87":"3ef1d78e","187":"c1fdee14","248":"8fb99f21","373":"3ef1d78e","484":"3ef1d78e","522":"a74cd599","780":"c2f8399b","995":"be61c5fa"}[chunkId] + ".chunk.css";
};